// src/redux/Users/reducer.js
import { USER_LIST, USER_PAGINATION } from './constant';

export const initStateFeed = {
    usersList: [],      // ← was "userList", must match component
    usersPagination: {},
};

export default (state = initStateFeed, action) => {
    switch (action.type) {
        case USER_LIST: {
            return { ...state, usersList: action.payload };
        }
        case USER_PAGINATION: {
            return { ...state, usersPagination: action.payload };
        }
        default:
            return state;
    }
};